package pwgs.ui.scenes.diagnosticserrorgroupsscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ADiagnosticsErrorGroupsControllerFe(props: pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsSceneProps, scene: MDiagnosticsErrorGroupsScene)
 : AController<pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsSceneProps, pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsSceneModel, DiagnosticsErrorGroupsSceneState>(props, scene) {

    val backend = DiagnosticsErrorGroupsControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class DiagnosticsErrorGroupsControllerBeProxy(private val controller: ADiagnosticsErrorGroupsControllerFe) {

    suspend fun load(): pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.diagnosticserrorgroupsscene.DiagnosticsErrorGroupsSceneModel.serializer())
        }
    }

}
